import React, {Component, Fragment} from 'react'
import {message, Table, Button, Form, Input, Row, Col} from 'antd';
import moment from 'moment';
import 'moment/locale/zh-cn';
import {getOrderShort, getPackages} from '../../api'
moment.locale('zh-cn');

class GoodsInfoView extends Component {
    constructor(props) {
        super(props);
        this.state = {
            packageDataSource: [],
        }
    }

    componentDidMount() {
        const orderId = this.props.location.state.orderId;
        this.orderShort(orderId);
        this.goods({orderId});
        this.setState({orderId: orderId});
    }

    orderShort = async (orderId) => {
        let result = await getOrderShort(orderId);
        if (result.code === 200) {
            let deliveryEstimateDt = result.data.deliveryEstimateDt ? result.data.deliveryEstimateDt.substr(0, 13) : '';
            let tradeDt = result.data.tradeDt ? result.data.tradeDt.substr(0, 13) : '';
            result.data.deliveryEstimateDt = deliveryEstimateDt;
            result.data.tradeDt = tradeDt;
            this.setState(result.data)
        } else {
            message.error(result.message)
        }
    };
    goods = async (values, page = 1, pageSize = 20) => {
        let result = await getPackages({...values, pageNum: page, pageSize});
        if (result.code === 200) {
            if (result.data) {
                this.setState({
                    page,
                    pageSize,
                    total: result.data.total,
                    packageDataSource: result.data.rows,
                })
            }
        }
        else {
            message.error(result.message)
            return false;
        }
    };
    goodsByValue = (page, pageSize) => {
        const values = this.props.form.getFieldsValue();
        values.orderId = this.state.orderId;
        this.goods(values, page, pageSize);
    };
    handleSubmit = e => {
        e.preventDefault();
        this.props.form.validateFields((err, values) => {
            values.orderId = this.state.orderId;
            if (!err) {
                this.goods(values);
            }
        });
    };

    render() {
        const {getFieldDecorator} = this.props.form;
        const {packageDataSource} = this.state;
        const columns = [
            {
                title: '客户单号',
                dataIndex: 'platOrderNo',
            }, {
                title: '大区',
                dataIndex: 'area',
            }, {
                title: '客户简称',
                dataIndex: 'customerName',
            }, {
                title: '运单号',
                dataIndex: 'deliveryNo',
            }, {
                title: '随箱编号',
                dataIndex: 'boxNo',
            }, {
                title: '报关类型',
                dataIndex: 'declareType',
            }, {
                title: '箱数CTNS',
                dataIndex: 'num',
            }, {
                title: '总重量(Kg)',
                dataIndex: 'grossWeight',
            }, {
                title: '净重(Kg)',
                dataIndex: 'netWeight',
            }, {
                title: '尺寸(cm)',
                dataIndex: 'size',
            }, {
                title: '体积(CBM)',
                dataIndex: 'volume',
            }, {
                title: '品名(中文)',
                dataIndex: 'name',
            }, {
                title: '品名(英文)',
                dataIndex: 'nameEn',
            }, {
                title: 'HSCode',
                dataIndex: 'hscode',
            }, {
                title: '数量PCS',
                dataIndex: 'pcsNumber',
            }, {
                title: '单件净重',
                dataIndex: 'unitNetWeight',
            }, {
                title: '单价/币制Value unit',
                dataIndex: 'originalValue',
                render: (text, record) => {
                    if (text != null) {
                        return text + '/' + record.originalCurrency;
                    }
                }
            }, {
                title: '总价/币制Value & Currency',
                dataIndex: 'originalTotalValue',
                render: (text, record) => {
                    if (text != null) {
                        return text + '/' + record.originalCurrency;
                    }
                }
            }, {
                title: '成分(备注比例)',
                dataIndex: 'ingredient',
            }, {
                title: '用途',
                dataIndex: 'application',
            }, {
                title: '链接',
                dataIndex: 'picUrl',
            }, {
                title: '品牌',
                dataIndex: 'brand',
            }
        ];
        return (
            <div className='order-info box-shadow padding-20'>
                <div className="head-title">
                    <div className='flex-between'>
                        <span className='title' style={{lineHeight: '32px'}}>订单详情</span>
                    </div>
                </div>
                <div className='order-info-content'>
                    <div className='order-space'>

                        <div className="order-base-title">
                            基本信息
                        </div>
                        <div className="space-base-content">
                            <div className="base-info" style={{height: 'auto'}}>
                                <Row>
                                    <Col span={12}>
                                        <span className='title'>起运地 : </span>
                                        <span
                                            className='address-detail'>{this.state.originCountry}&nbsp;{this.state.originCity}</span>
                                    </Col>
                                    <Col span={12}>
                                        <span className='title'>目的地:</span>
                                        <span
                                            className='address-detail'>{this.state.destinationCountry}&nbsp;{this.state.destinationCity}</span>
                                    </Col>
                                    <Col span={12}>
                                        <span className='title'>集装箱数 : </span>
                                        <span className='address-detail'>{this.state.containerNum}</span>
                                    </Col>
                                    <Col span={12}>
                                        <span className='title'>贸易时间:</span>
                                        <span className='address-detail'>{this.state.tradeDt}</span>
                                    </Col>
                                    <Col span={12}>
                                        <span className='title'>采购单号 : </span>
                                        <span className='address-detail'>{this.state.purchaseNo}</span>
                                    </Col>
                                    <Col span={12}>
                                        <span className='title'>发票编号:</span>
                                        <span className='address-detail'>{this.state.invNo}</span>
                                    </Col>
                                    <Col span={12}>
                                        <span className='title'>订单编号 : </span>
                                        <span className='address-detail'>{this.state.orderNo}</span>
                                    </Col>
                                    <Col span={12}>
                                        <span className='title'>货物包装:</span>
                                        <span className='address-detail'>{this.state.packageKind}</span>
                                    </Col>
                                </Row>
                            </div>
                        </div>
                        <div className="order-base-title">国内仓库信息</div>
                        <div className="space-base-content">
                            <div className="base-info" style={{height: 'auto'}}>
                                <Row>
                                    <Col span={12}>
                                        <span className='title'>仓库地址 : </span>
                                        <span className='address-detail'>{this.state.deliveryPlace}</span>
                                    </Col>
                                    <Col span={12}>
                                        <span className='title'>预计提货时间:</span>
                                        <span
                                            className='address-detail'>{this.state.deliveryEstimateDt ? this.state.deliveryEstimateDt.substr(0, 13) : ''}</span>
                                    </Col>
                                    <Col span={12}>
                                        <span className='title'>仓库联系人 : </span>
                                        <span className='address-detail'>{this.state.contact}</span>
                                    </Col>
                                    <Col span={12}>
                                        <span className='title'>仓库联系方式:</span>
                                        <span className='address-detail'>{this.state.contactTel}</span>
                                    </Col>
                                </Row>
                            </div>
                        </div>
                        {this.state.deliveryPlace2 != null ? <Fragment>
                            <div className="order-base-title">国内仓库信息2</div>
                            <div className="space-base-content">
                                <div className="base-info" style={{height: 'auto'}}>
                                    <Row>
                                        <Col span={12}>
                                            <span className='title'>仓库地址 : </span>
                                            <span className='address-detail'>{this.state.deliveryPlace2}</span>
                                        </Col>
                                        <Col span={12}>
                                            <span className='title'>仓库联系方式:</span>
                                            <span className='address-detail'>{this.state.contactTel2}</span>
                                        </Col>
                                        <Col span={12}>
                                            <span className='title'>仓库联系人 : </span>
                                            <span className='address-detail'>{this.state.contact2}</span>
                                        </Col>
                                    </Row>
                                </div>
                            </div>
                        </Fragment> : null}
                        <div className="order-base-title">清关仓库信息(通知方)</div>
                        <div className="space-base-content">
                            <div className="base-info" style={{height: 'auto'}}>
                                <Row>
                                    <Col span={12}>
                                        <span className='title'>仓库名称 : </span>
                                        <span className='address-detail'>{this.state.notifyParty}</span>
                                    </Col>
                                    <Col span={12}>
                                        <span className='title'>仓库地址:</span>
                                        <span className='address-detail'>{this.state.notifyPartyAddr}</span>
                                    </Col>
                                    <Col span={12}>
                                        <span className='title'>仓库联系人 : </span>
                                        <span className='address-detail'>{this.state.notifyPartyContact}</span>
                                    </Col>
                                    <Col span={12}>
                                        <span className='title'>仓库联系方式:</span>
                                        <span className='address-detail'>{this.state.notifyPartyTel}</span>
                                    </Col>
                                </Row>
                            </div>
                        </div>
                        <div className="order-base-title">目的仓库信息(卸货仓)</div>
                        <div className="space-base-content">
                            <div className="base-info" style={{height: 'auto'}}>
                                <Row>
                                    <Col span={12}>
                                        <span className='title'>仓库名称 : </span>
                                        <span className='address-detail'>{this.state.consignee}</span>
                                    </Col>
                                    <Col span={12}>
                                        <span className='title'>仓库地址:</span>
                                        <span className='address-detail'>{this.state.consigneeAddr}</span>
                                    </Col>
                                    <Col span={12}>
                                        <span className='title'>仓库联系人 : </span>
                                        <span className='address-detail'>{this.state.consigneeContact}</span>
                                    </Col>
                                    <Col span={12}>
                                        <span className='title'>仓库联系方式:</span>
                                        <span className='address-detail'>{this.state.consigneeTel}</span>
                                    </Col>
                                </Row>
                            </div>
                        </div>
                        <div className="order-base-title">
                            商品信息
                        </div>
                        <div className="order-goods-content">
                            <Form onSubmit={this.handleSubmit} labelCol={{
                                lg: {span: 6},
                                md: {span: 7},
                            }} wrapperCol={{
                                lg: {span: 14},
                                md: {span: 12},
                            }}>
                                <Row>
                                    <Col span={8}>
                                        <Form.Item label="客户单号">
                                            {getFieldDecorator('platOrderNo', {})(<Input />)}
                                        </Form.Item>
                                    </Col>
                                    <Col span={8}>
                                        <Form.Item label="运单号">
                                            {getFieldDecorator('deliveryNo', {})(<Input />)}
                                        </Form.Item>
                                    </Col>
                                    <Col span={8}>
                                        <Form.Item label="随箱编号">
                                            {getFieldDecorator('boxNo', {})(<Input />)}
                                        </Form.Item>
                                    </Col>
                                    <Col span={8}>
                                        <Form.Item label="品名">
                                            {getFieldDecorator('name', {})(<Input />)}
                                        </Form.Item>
                                    </Col>
                                    <Col span={8} style={{float: 'right', marginBottom: '20px'}}>
                                        <Button type='primary' htmlType="submit"
                                                style={{float: 'right', marginRight: '14%'}}>查询</Button>
                                    </Col>
                                </Row>
                            </Form>
                            <Table columns={columns} bordered scroll={{x: 1300}} dataSource={packageDataSource}
                                   size="middle" pagination={{
                                current: this.state.page,
                                pageSize: this.state.pageSize ? this.state.pageSize : 20,
                                total: this.state.total,
                                pageSizeOptions: ['20', '50', '100'],
                                showSizeChanger: true,
                                onShowSizeChange: (page, pageSize) => {
                                    this.goodsByValue(page, pageSize);
                                },
                                onChange: (page, pageSize) => {
                                    this.goodsByValue(page, pageSize);
                                },
                                showTotal: (total) => `共计 ${total} 条`,
                            }}/>
                        </div>
                    </div>
                </div>
            </div>
        )
    }
}

const WrapGoodsInfoView = Form.create()(GoodsInfoView)
export default WrapGoodsInfoView